import React from 'react';
import styles from './CloudProviderLogo.module.less';

const CloudProviderLogo: React.FC<{ url: string }> = ({ url }) => (
    <img src={url} alt={url} className={styles.CloudProviderLogo} />
);
export default CloudProviderLogo;
